import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class ProductionLogIdRequest{
    @ApiProperty()
    productionLogId:number;
    @ApiProperty()
    @IsOptional()
    opBoxes?:number;
    @ApiProperty()
    @IsOptional()
    outputQuantity?:number
    constructor(productionLogId:number,opBoxes?:number,outputQuantity?:number){
        this.productionLogId = productionLogId;
        this.opBoxes = opBoxes;
        this.outputQuantity = outputQuantity;
    }
}